import { RowAdministratorApplicationDto } from "@/dtos";
import { AdministratorApplication } from "@/entities";

export const formatTableAdminApplicationsDto = (adminApplications: AdministratorApplication[]):
    RowAdministratorApplicationDto[] => {
    return adminApplications.map((x) => {
        const obj: RowAdministratorApplicationDto = {
            id: x.id,
            name: x.application.name,
            description: x.application.description,
            is_active: x.is_active,
            status: (x.is_active) ? 'Activo' : 'Inactivo'
        }
        return obj;
    });
}